import React, {useRef, useState, useEffect, useCallback} from 'react'
import classNames from 'classnames'
import {Button, Fade, Paper, Popper} from '@material-ui/core'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

import {ImageCollections} from '../../utils/imageImports'
import SXTLiveNotificationBell from '../common/SXTNotificationBell/SXTLiveNotificationBell'
import NotificationPopper from './NotificationPopper'
import {
  getDrupalNotificationsCount,
  getNotificationCountRedis,
  updateNotificationCountRedis,
} from '../../queries/notificationQuery'

import './notification.scss'
import {compose, getContext} from 'recompose'
import {graphql, withApollo} from 'react-apollo'
import {targetPropTypes} from '../../commonPropsType'
import ApolloClient from 'apollo-client'
import {checkObjProps} from '../../utils/genericUtils'

interface IProps {
  drupCount: number
  citrixId: string
  client: ApolloClient<{query: {}}>
  isWindowActive: Boolean
  saveNotificationCountRedis
  notificationCountRedis: number
}

const Notification = props => {
  const [showPopper, setShowPopper] = useState(false)
  const anchorRef = useRef<HTMLButtonElement | null>(null)

  const {drupCount} = props
  const [count, setCount] = React.useState(drupCount)

  const handleToggle = useCallback((open: boolean) => {
    setShowPopper(open)
  }, [])

  useEffect(() => {
    const newCount = drupCount
    if (props.notificationCountRedis === newCount) setCount(0)
    else setCount(newCount)

    if (showPopper) {
      props.client
        .mutate({
          mutation: updateNotificationCountRedis,
          variables: {data: newCount},
          refetchQueries: [
            {
              query: getNotificationCountRedis,
            },
          ],
        })
        .catch(err => {
          console.error('Error resetting notification count:', err)
        })
    }
  }, [showPopper, drupCount, props.notificationCountRedis, count])

  return (
    <div className="header-notification">
      <Button
        ref={anchorRef}
        className={classNames('user-btn', {active: showPopper})}
        aria-haspopup="true"
        onClick={() => handleToggle(true)}
        data-testid="header-notification"
      >
        <img
          src={ImageCollections.ico_bell}
          alt="Notification icon"
          className="bell-icon"
        />
        <SXTLiveNotificationBell count={count} />
      </Button>

      <Popper
        open={showPopper}
        anchorEl={anchorRef.current}
        transition
        placement="bottom-end"
        disablePortal
        className="header-notification-pop"
      >
        {({TransitionProps}) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper className="notification-paper">
              <span className="arrow-tip" />
              <ClickAwayListener onClickAway={() => handleToggle(false)}>
                <NotificationPopper handleToggle={handleToggle} />
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  )
}

export default React.memo(
  compose(
    withApollo,
    getContext(targetPropTypes),
    graphql(getDrupalNotificationsCount, {
      options: (props: any) => ({
        variables: {empId: props.citrixId},
        notifyOnNetworkStatusChange: true,
        pollInterval: props.isWindowActive ? 1800000 : 0, // Poll only if window is active,
      }),
      props: ({data}: any) => {
        return {
          drupCount: data.notificationsCount || 0,
        }
      },
    }),
    graphql(updateNotificationCountRedis, {
      name: 'saveNotificationCountRedis',
    }),
    graphql(getNotificationCountRedis, {
      options: () => ({
        notifyOnNetworkStatusChange: true,
      }),
      props: ({data}: any) => {
        return {
          notificationCountRedis: checkObjProps(
            data,
            ['getNotificationCount', 'notificationCount'],
            0
          ),
        }
      },
    })
  )(Notification)
)
